<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-2">
                        <az-input   
                            type="month"
                            v-model="filtro.ref_mes">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load()">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-4">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fa fa-building-o fa-fw" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                            <select class="form form-control" v-model="filtro.id_unidade_operacao">
                                <option value="">Unidades...</option>
                                <option v-for="(und, iux) in $util.unidades_com_tags(false, true)" 
                                    :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="col col-12 col-md-2">
                        <az-input 
                            type="checkbox-group"
                            label="Externo"
                            v-model="filtro.externo" />
                    </div>

                    <div class="col col-12 col-md-4">
                        <az-input 
                            placeholder="Todos os Locais..."
                            icon="fas fa-clinic-medical fa-fw"
                            type="select"
                            optionsMode="aql"
                            service="centro_cirurgicos.index"
                            optionsData="id_centro_cirurgico" 
                            optionsDisplay="st_centro_cirurgico"
                            :optionsParm="{ ativos: true }"
                            :edicao="filtro.externo"
                            v-model="filtro.id_centro_cirurgico"  />
                    </div>
                    
                </div>

            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state icon="far fa-calendar-plus" msg="Nenhuma escala gerada para repetição." v-if="!dados || !dados.length" />

        <template v-else>

            <div class="mb-3">
                <button type="button" class="btn btn-outline-primary mr-1" @click="selecionar_todos()">
                    Selecionar Todos
                </button>

                <button type="button" class="btn btn-success" @click="abrir_escalas()" :disabled="!selecionados.length">
                    Abrir Escalas
                </button>
            </div>

            <ul class="list-group">
                <li class="list-group-item" v-for="(repeticao, irx) in dados" :key="irx">
                    <div class="row">
                        <div class="col col-12 col-md-1">
                            <az-input
                                type="checkbox" 
                                v-model="repeticao.selec" />
                        </div>
                        <div class="col col-12 col-md-9">
                            <div class="h4">
                                {{ repeticao.usuario.pessoa.st_nome }}
                            </div>
                            <escala-agenda-show :agenda="repeticao.agenda" />    
                        </div>
                        <div class="col col-12 col-md-2">
                            <div v-if="repeticao.js_repeticao.repeticao == 'S'" class="text-right">
                                <div class="lead">Semanal</div>
                                <div>
                                    {{ dias_da_semana(repeticao.js_repeticao.js_dias_da_semana) }}
                                </div>
                            </div>

                            <div v-if="repeticao.js_repeticao.repeticao == 'I'" class="text-right">
                                <div class="lead">Intervalo</div>
                                <div>
                                    {{ repeticao.js_repeticao.repetir.intervalo }}
                                    {{ repeticao.js_repeticao.repetir.intervalo > 1 ? 'dias' : 'dia' }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-if="false">
                        <div>
                            <div class="h4">
                                {{ repeticao.usuario.pessoa.st_nome }}
                            </div>
                            <escala-agenda-show :agenda="repeticao.agenda" />
                        </div>
                        <div>
                            <div v-if="repeticao.js_repeticao.repeticao == 'S'" class="text-right">
                                <div class="lead">Semanal</div>
                                <div>
                                    {{ dias_da_semana(repeticao.js_repeticao.js_dias_da_semana) }}
                                </div>
                            </div>

                            <div v-if="repeticao.js_repeticao.repeticao == 'I'" class="text-right">
                                <div class="lead">Intervalo</div>
                                <div>
                                    {{ repeticao.js_repeticao.repetir.intervalo }}
                                    {{ repeticao.js_repeticao.repetir.intervalo > 1 ? 'dias' : 'dia' }}
                                </div>
                            </div>
                        </div>
                    </template>
                </li>
            </ul>

        </template>

        <!-- Modal Seleção Período -->
        <div class="modal fade" id="abrirEscalasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Abrir escalas para</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            type="month"
                            label="Mês"
                            required
                            :validate="validate"
                            v-model="mes_destino" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_abrir_escalas()">Abrir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <pre v-if="false">{{ dados }}</pre>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import EscalaAgendaShow from './EscalaAgendaShow.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            filtro: { 
                id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'), 
                ref_mes: this.$util.hoje().substr(0,7),
                externo: true, 
                id_centro_cirurgico: "", 
                breadcrumb: null,
            }, 

            dados: null, 

            mes_destino: "", 
            validate: false, 
        }
    },

    components: { 
        AzInput,
        AzSubmit,
        AzEmptyState,
        EscalaAgendaShow,
    },

    computed: { 
        selecionados: function () { 
            if ( !this.dados )
                return [];

            return this.dados.filter(item => item.selec);
        }
    },

    methods: { 
        salvar_abrir_escalas () { 
            this.$util.atualizar(this, { 
                service: 'plantao_escalas',
                func: 'abrir_escalas',
                dados: { 
                    mes_destino: this.mes_destino,
                    lista: this.selecionados.map(item => { 
                        return { 
                            id_plantao_repeticao: item.id_plantao_repeticao,
                        };
                    }),
                },
                modal: 'abrirEscalasModal',
                toast: true, 
                reload: true, 
            });
        },

        abrir_escalas () { 
            this.mes_destino = "";
            this.validate = false;

            $('#abrirEscalasModal').modal('show');
        },

        selecionar_todos () { 
            let opcao = this.dados.find(item => item.selec) ? false : true; 

            this.dados.forEach(item => {
                item.selec = opcao;
            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'plantao_repeticoes',
                func: 'index',
                parms: { 
                    abertura: true,
                    cadastro: true,  
                    ...this.filtro,
                }, 
                loadTo: res => { 
                    this.dados = res;
                }
            });
        },

        dias_da_semana(dias) { 
            return dias.map((item, key) => item ? this.nome_dia(key) : null )
                .filter(item => item)
                .join(', ');
        },

        nome_dia(dia) { 
            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sab';
            }

            return '?';
        },
    },

    mounted() { 
        this.breadcrumb = [
                { name: "Escalas", path: "/escalas/escalas"},
                { name: "Abertura de Escala" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.load();
    }
}
</script>